module.exports = __webpack_public_path__ + "static/media/ic_show_aos_hover.72f3ddc4.svg";